const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    margin: "-2px 0px",

    "&:hover $hidableResults": {
      opacity: 1,
      width: "auto",
      maxWidth: "500px",
      visibility: "visible",
      marginLeft: "-40px",
      paddingLeft: "50px",
    },
  },
  iconGreen: {
    color: "green",
    cursor: "pointer",
    userSelect: "none",
    zIndex: 1000,
    marginLeft: 5,
  },
  iconGray: {
    color: "gray",
    cursor: "pointer",
    userSelect: "none",
    zIndex: 1000,
    marginLeft: 5,
    filter: "grayscale(100%)",
  },
  hidableResults: {
    background: "#f5f5f5",
    border: "2px solid #e0e0e0",
    borderRadius: "4px",
    padding: "5px 10px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginLeft: 10,
    opacity: 0,
    width: 0,
    maxWidth: 0,
    visibility: "hidden",
    transition:
      "opacity 0.3s ease-in-out, width 0.3s ease-in-out, max-width 0.3s ease-in-out, visibility 0s ease-in-out",
    whiteSpace: "nowrap",
  },
});

export default styles;
